//3rd party
import React from 'react';
import i18next from 'i18next';
import Select, { ClearIndicatorProps, MultiValue, components } from 'react-select';
import { CSSObject } from '@emotion/serialize';
import { DropDownItem, DropdownProps } from './FormElementsTypes';
import { Checkbox } from 'components';

const CustomClearText = () => <>{i18next.t('clear_all', { ns: 'common' })}</>;

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const ClearIndicator = (props: ClearIndicatorProps<any, true>): JSX.Element => {
  const {
    children = <CustomClearText />,
    innerProps: { ref, ...restInnerProps }
  } = props;
  return (
    <div {...restInnerProps} ref={ref}>
      <div style={{ padding: '0px 5px' }}>{children}</div>
    </div>
  );
};

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const DropdownIndicator = (props: ClearIndicatorProps<any, true>): JSX.Element => {
  const {
    innerProps: { ref, ...restInnerProps }
  } = props;
  return (
    <div style={{ padding: '0px 12px' }} {...restInnerProps} ref={ref}>
      <svg
        style={{ width: '10px' }}
        aria-hidden="true"
        focusable="false"
        data-prefix="fas"
        data-icon="sort-down"
        className="svg-inline--fa fa-sort-down "
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320 512"
      >
        <path
          fill="currentColor"
          d="M311.9 335.1l-132.4 136.8C174.1 477.3 167.1 480 160 480c-7.055 0-14.12-2.702-19.47-8.109l-132.4-136.8C-9.229 317.8 3.055 288 27.66 288h264.7C316.9 288 329.2 317.8 311.9 335.1z"
        ></path>
      </svg>
    </div>
  );
};

/* eslint-disable-next-line  @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types */
export const Option = (props: any): JSX.Element => {
  return (
    <div>
      <components.Option {...props}>
        <Checkbox
          width={18}
          height={18}
          margin="0"
          label={props.label}
          labelWeight={400}
          fontSize={14}
          checked={props.isSelected}
          onChange={() => null}
        />
      </components.Option>
    </div>
  );
};

export const ClearValues = (
  base: CSSObject,
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types */
  state: ClearIndicatorProps<any>
): CSSObject => ({
  ...base,
  cursor: 'pointer',
  color: state.isFocused ? 'blue' : 'black'
});

export const DropdownWithCheckboxes = ({
  disabled,
  options,
  value,
  handleMultiSelect,
  ariaLabel,
  placeholder
}: DropdownProps): JSX.Element => {
  const handleInputOnChange = (e: MultiValue<DropDownItem>) => {
    handleMultiSelect([...e]);
  };

  return (
    <Select
      isDisabled={disabled ? true : false}
      className={disabled ? 'dropdown_checkboxes select--disabled' : 'dropdown_checkboxes'}
      hideSelectedOptions={false}
      aria-label={ariaLabel}
      isClearable={false}
      closeMenuOnSelect={false}
      components={{
        Option,
        ClearIndicator,
        DropdownIndicator
      }}
      styles={{
        clearIndicator: ClearValues,
        multiValue: (styles) => {
          return {
            ...styles,
            backgroundColor: 'white',
            borderRadius: '1.25rem',
            border: '0.063rem solid  #0076CC',
            padding: '0.25rem 0.5rem 0.25rem 0.5rem;'
          };
        },
        multiValueLabel: (styles) => ({
          ...styles,
          fontWeight: '400'
        }),
        multiValueRemove: (styles) => ({
          ...styles,
          ':hover': {
            cursor: 'pointer'
          }
        })
      }}
      defaultValue={value}
      isMulti
      options={options}
      onChange={(e) => handleInputOnChange(e)}
      placeholder={placeholder}
    />
  );
};
